<template>
  <div :style="{ height: props.isScroll ? '75vh' : '100%' }">
  <div v-for="form in props.forms" :key="form.id">
    <template v-if="form.id === 'approval'">
      <slot name="approval"></slot>
    </template>
    <h4 v-if="!form.hidden && form.name">{{ form.name }}</h4>
    <action_form
      v-if="!form.dynamic && !form.hidden"
      v-bind="form"
      :itemCol="props.itemCol"
      :itemHeight="props.itemHeight"
      :ref="(el) => (formRefs[form.id] = el)"
      :collection="initFormData(form.formItem, form)"
      :disabledDate="props.disabledDate"
      :disabled="disabled"
      :labelCol="props.labelCol"
    ></action_form>
    <dynamic_action_form
      v-else-if="!form.hidden"
      v-bind="form"
      :ref="(el) => (formRefs[form.id] = el)"
      :edit="props.edit"
      :editData="props.editData"
      :collection="initFormData(form.formItem, form)"
      :disabled="disabled"
      :labelCol="props.labelCol"
    ></dynamic_action_form> 
  </div>
  </div>
  <slot></slot>
  <a-button
    type="primary"
    @click="onSubmit"
    block
    size="large"
    v-if="props.submitBtn"
    :style="{
      ...(props.isScroll ?
        {
          position: 'absolute',
          bottom: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '80%',
        }
        : {}
      )
    }"
  >
    {{ props.submitText }}
  </a-button>
</template>

<script setup>
  import { defineProps, ref, defineEmits, defineExpose } from 'vue'
  import action_form from '@/components/action_form'
  import dynamic_action_form from '@/components/dynamic_action_form'
  //初始化
  const props = defineProps({
    forms: Array,
    editData: Object,
    itemCol: Number,
    itemHeight: String,
    disabledDate: Function,
    edit: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    submitText: { type: String, default: '保存' },
    submitBtn: { type: Boolean, default: true },
    labelCol: { type: Object, default: () => ({ span: 7, offset: 0 }) },
    isScroll: { type: Boolean, default: true },
  })
  const formRefs = ref({})
  initFormRefs(formRefs, props.forms)
  const emit = defineEmits(['submit'])

  //初始化表单ref
  function initFormRefs(formRefs, forms) {
    forms.forEach((item) => {
      formRefs.value[item.id] = ref()
    })
  }

  //编辑模式，初始化默认值
  function initFormData(collection, option) {
    if (!props.editData) return collection
    collection.forEach((item) => {
      const name = item.field
      item.disabled =
        item.disabled === undefined ? props.disabled : item.disabled
      let editData = props.editData
      if (item.dataInObject || option.dataInObject)
        editData = props.editData[item.dataInObject || option.dataInObject]
      if (item.type === 'dateRange') {
        item.defaultStart = editData[item.startField]
        item.defaultEnd = editData[item.endField]
      } else if (item.type === 'addressPicker') {
        item.defaultLat = editData[item.latField]
        item.defaultLng = editData[item.lngField]
      } else if (editData?.[name] !== undefined) {
        item.defaultValue ??= editData?.[name]
      }
    })
    return collection
  }

  function onSubmit() {
    let payload = {}

    Object.keys(formRefs.value).forEach((key) => {
      const item = formRefs.value[key]
      if (!item) return
      const inObject = item?.submitInObject
      if (item.formState?.constructor === Array || inObject) {
        payload[key] = item.formState
      } else if (item.formState?.constructor === Object) {
        payload = { ...payload, ...item.formState }
      }
    })

    emit('submit', payload)
  }

  defineExpose({ formRefs })
</script>

<style lang="less" scoped>
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 16px;

  :deep(.ant-form-item) {
    margin-bottom: 8px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}
</style>
